import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';
import { TextField, SelectField, Checkbox } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';

class UserForm extends Component {
  static validate = (values, props) => {
    const role = _.get(props, 'user.profile.roles');
    const errors = {};
    const requiredFields = ['name', 'username', 'password', 'roles'];

    requiredFields.forEach((item) => {
      if (!values[item]) {
        errors[item] = 'Required';
      }
    });

    if (values.isShipper) {
      if (!values.carrierId) {
        errors.carrierId = 'Required if marked as shipper';
      }
      if (!values.shipperId) {
        errors.shipperId = 'Required if marked as shipper';
      }
    }

    return errors;
  }

  renderTextField = props => (
    <TextField hintText={props.label} floatingLabelText={props.label} errorText={props.touched && props.error} {...props} fullWidth />
  );

  render() {
    const { user, handleSubmit, submitting, companies } = this.props;
    const buttonText = (submitting) ? 'Saving...' : 'Save';
    const role = _.get(user, 'profile.roles');

    const companyList = _.get(companies, 'list', []).map(item => <MenuItem value={item.id} primaryText={item.name} key={`${item.id}-cokey`} />);

    let roleTypes = [role];
    if (_.includes(['super-admin', 'carrier-admin'], role)) {
      roleTypes = [
        <MenuItem value="carrier-admin" primaryText="Carrier Admin" key={`${1}-role`} />,
        <MenuItem value="carrier-dispatch" primaryText="Dispatcher" key={`${2}-role`} />,
        <MenuItem value="carrier-dock" primaryText="Warehouse" key={`${3}-role`} />,
        <MenuItem value="shipper-admin" primaryText="Shipper Admin" key={`${4}-role`} />,
        <MenuItem value="shipper-read" primaryText="Shipper (Read Only)" key={`${5}-role`} />,
      ]
    } else if (role === 'shipper-admin') {
      roleTypes = [
        <MenuItem value="shipper-admin" primaryText="Shipper Admin" key={`${1}-role`} />,
        <MenuItem value="shipper-read" primaryText="Shipper (Read Only)" key={`${2}-role`} />,
      ]
    }

    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col s6">
            <Field name="username" label="Username" component={this.renderTextField} />
          </div>
          <div className="col s6">
            <Field name="password" label="Password" component={this.renderTextField} type="password" />
          </div>
        </div>
        <div className="row">
          <div className="col s6">
            <Field name="name" label="Name" component={this.renderTextField} />
          </div>
          <div className="col s6">
            <Field name="roles" type="text" component={SelectField} floatingLabelText="Role" fullWidth>
              {roleTypes}
            </Field>
          </div>
        </div>
        {_.includes(['super-admin', 'carrier-admin'], role) &&
        <div className="row">
          {_.includes(['super-admin'], role) &&
          <div className="col s6">
            <Field name="carrierId" type="text" component={SelectField} floatingLabelText="Carrier" fullWidth>
              <MenuItem value="1" primaryText="BSI" />
            </Field>
          </div>
          }
          <div className="col s6">
            <Field name="shipperId" type="text" component={SelectField} floatingLabelText="Shipper" fullWidth>
              {companyList}
            </Field>
          </div>
        </div>
        }
        {_.includes(['super-admin', 'carrier-admin'], role) &&
        <div className="row">
          <div className="col s6">
            <Field name="isShipper" component={Checkbox} label="User is a shipper?" />
          </div>
        </div>
        }
        <div className="row">
          <div className="col s4 right">
            <RaisedButton fullWidth onClick={handleSubmit} disabled={submitting}>{buttonText}</RaisedButton>
          </div>
        </div>
      </form>
    );
  }
}


export default reduxForm({
  form: 'userForm',
  validate: UserForm.validate
})(UserForm);


// WEBPACK FOOTER //
// ./src/components/Users/Edit.js